<template>
  <div class="orderCenter">
    <div class="orderCenter-top">
      <div class="top-item">我的预约</div>
      <div class="top-navs">
        <div
          v-for="(item, index) in navlist"
          :key="index"
          @click="changenav(item.id)"
          class="navs-item"
          :class="item.id == navsindex ? 'active' : ''"
        >
          <div>{{ item.name }}</div>
          <div
            class="borderBottom"
            :class="item.id == navsindex ? 'active' : ''"
          ></div>
        </div>
      </div>
    </div>
    <div class="orderCenter-bottom">
      <div
        class="bottom-item"
        v-for="(item, index) in datalist"
        :key="index"
        :class="index != 0 ? 'active' : ''"
      >
        <div class="bottom-item-left">
          <div class="bottom-item-left-title1">
            {{ item.tourName }}
          </div>
          <div class="bottom-item-left-title2">
            预约时间：{{ item.appointDate }} {{ item.appointTimeStart }}-{{
              item.appointTimeEnd
            }}
          </div>
          <div class="bottom-item-left-title2">姓名：{{ item.name }}</div>
          <div
            class="bottom-item-left-title3"
            @click="
              deleteshow = true;
              deleteid = item.id;
            "
            v-if="item.status == 2"
          >
            取消预约
          </div>
        </div>
        <div class="ma" v-if="item.status == 2">
          <img :src="item.qrcode" alt="" @click="myma(item)" />
          <div style="font-size: 0.1rem; color: #AA2020">点击查看预约码</div>
        </div>
      </div>
      <div v-if="datalist.length == 0" class="nobottom">
        <img src="../assets/appointment.png" alt="" />
      </div>
      <div class="prompt">
        <p>温馨提示：</p>
        <p>
          1、实行实名制全预约制度，观众可提前七天通过线上渠道进行参观预约。如未提前预约且参观当日仍有余票时，观众可在当日进行预约。
        </p>
        <p>
          2、每张有效身份证件每天限定预约一次，单个账号每天最多实名预约3人(每个人的姓名和有效证件号码均需如实填写)，信息不符将不能进入，敬请周知。
        </p>
        <p>
          3、为未成年人预约前，请先为其申请【亲属随申码】，再使用对应的身份证号码为其预约，参观时出示预约码。
        </p>
        <p>4、 预约成功后出示个人随申码或预约二维码均可进入。</p>
        <p>
          5、如您不能按时到达，请提前取消预约（取消截止时间为您的预约进入时间段结束时间之前)。连续三次或累计五次（30天之内）
          预约未到，将触发限制预约机制，限制预约机制触发之后30日以内，将无法预约参观。
        </p>
        <p>6、本单位试行限流措施，请在预约时间段入场，过时不候。</p>
        <p>谢谢理解和配合！</p>
      </div>
    </div>
    <div class="pull" v-if="show" @click="onpull($event)">
      <img :src="myurl.url" alt="" width="80%" />
    </div>
    <el-dialog
      :visible.sync="deleteshow"
      width="70%"
      :show-close="false"
      :close-on-click-modal="false"
      class="el-dialog-centent"
    >
      <div class="pull-con">
        <div class="pull-con-title1">温馨提示</div>
        <div class="pull-con-title2">确定取消预约吗？</div>
        <div class="pull-button">
          <div
            @click="deleteshow = false"
            style="background-color: rgba(170, 32, 32, 0.3); color: #AA2020"
          >
            取消
          </div>
          <div @click="cancel" style="background-color: #AA2020; color: #fff">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //订单列表状态
      navlist: [
        {
          name: "已预约",
          id: 2,
        },
        {
          name: "已完成",
          id: 3,
        },
        {
          name: "已取消",
          id: 4,
        },
        {
          name: "已过期",
          id: 5,
        },
      ],
      //默认订单列表状态状态
      navsindex: 2,
      //全部订单
      datalistAll: null,
      //当前状态订单
      datalist: [],
      //预约码
      myurl: "",
      show: false,
      deleteshow: false,
      deleteid: "",
      timer: null,
    };
  },
  watch: {
    //点击类别重新筛选相应状态的数据
    navsindex(val) {
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        this.changenav(val);
      }, 50000);
    },
  },
  created() {
    this.getdata(2);
  },
  methods: {
    //点击类别
    changenav(index) {
      this.$axios.get("/book/appointmentInfos?status=" + index).then((res) => {
        this.datalist = res.data.rows;
        this.navsindex = index;
      });
    },
    //获取订单列表
    getdata(val) {
      this.changenav(val);
      this.timer = setInterval(() => {
        this.changenav(val);
      }, 50000);
      this.tokenshow = true;
    },
    //取消列表
    cancel() {
      this.deleteshow = false;
      this.$axios.get("book/cancel?id=" + this.deleteid).then(() => {
        this.getdata(this.navsindex);
      });
    },
    //预览二维码
    myma(data) {
      this.myurl = {
        url: data.qrcode,
        id: data.id,
      };
      this.getOneUrl();
      this.timer1 = setInterval(() => {
        this.getOneUrl();
      }, 50000);
      this.show = true;
    },
    getOneUrl() {
      this.$axios.get("/book/appointmentInfos").then((res) => {
        let dataList = res.data.rows;
        let updateUrl = dataList.filter((item) => item.id == this.myurl.id);
        this.$set(this.myurl, "url", updateUrl[0].qrcode);
      });
    },
    //点击别处关闭二维码
    onpull($event) {
      if ($event.target.nodeName == "DIV") {
        this.show = false;
        clearInterval(this.timer1);
        this.timer1 = null;
        this.myurl = "";
      }
    },
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.timer1);
    this.timer = null;
    this.timer1 = null;
  },
};
</script>
<style>
.el-dialog-centent {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-dialog {
  margin: 0 0 !important;
  display: flex;
  flex-direction: column;
}
.el-dialog__header {
  display: none;
}
</style>
<style  lang="less" scoped>
.orderCenter {
  .orderCenter-top {
    width: 100%;
    background-color: #AA2020;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .top-item {
      font-size: 0.22rem;
      color: #fff;
      padding-top: 0.3rem;
    }
    .top-navs {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-top: 0.2rem;
      padding-bottom: 0.4rem;
      .navs-item {
        color: rgba(255, 255, 255, 0.8);
        width: 25%;
        text-align: center;
        .borderBottom {
          width: 0.35rem;
          height: 0.03rem;
          background-color: transparent;
          margin: 0 auto;
          margin-top: 0.05rem;
        }
        .active {
          background-color: #fff;
        }
      }
      .active {
        color: #fff;
      }
    }
  }
  .orderCenter-bottom {
    background-color: #fff;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    position: relative;
    top: -0.2rem;
    padding: 0.1rem 0.2rem 0 0.2rem;
    box-sizing: border-box;
    .bottom-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.2rem;
      padding: 0.2rem 0 0.1rem 0;
      .bottom-item-left {
        width: 70%;
        .bottom-item-left-title1 {
          color: #142323;
          font-size: 0.18rem;
          margin-bottom: 0.1rem;
        }
        .bottom-item-left-title2 {
          color: #868686;
          font-size: 0.12rem;
          margin-bottom: 0.07rem;
        }
        .bottom-item-left-title3 {
          background-color: rgba(170, 32, 32, 0.2);
          color: #AA2020;
          width: 0.9rem;
          line-height: 0.35rem;
          text-align: center;
          border-radius: 0.05rem;
          margin-top: 0.2rem;
          font-size: 0.15rem;
        }
      }
      .ma {
        width: 0.7rem;
        height: 0.7rem;
        text-align: center;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .nobottom {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .active {
      border-top: 1px solid #ccc;
    }
    .prompt {
      font-size: 0.1rem;
      color: #a0a0a0;
      margin-top: 0.3rem;
      line-height: 0.18rem;
    }
  }
  .pull {
    position: fixed;
    max-width: 768px;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pull-con {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .pull-con-title1 {
      font-weight: 500;
      color: #142323;
      letter-spacing: 1px;
      font-size: 0.2rem;
      font-weight: 600;
      text-align: center;
    }
    .pull-con-title2 {
      margin-top: 0.2rem;
      font-size: 0.12rem;
      p {
        margin-bottom: 0.1rem;
        color: #142323;
        letter-spacing: 2px;
      }
    }
    .pull-button {
      width: 100%;
      line-height: 0.31rem;
      // font-size: 0.14rem;
      // text-align: center;
      // border-radius: 0.04rem;
      margin-top: 0.2rem;
      display: flex;
      justify-content: space-between;
      text-align: center;
      div {
        width: 40%;
        border-radius: 0.04rem;
      }
    }
  }
}
</style>